define('services/events/animated-session-events',[
    // Libs
    'jquery',
    'underscore',
    'backbone',
    'mustache',
    'utils',
    // class
    'src/event-aggregator'

], function(
    // Libs
    $, _, Backbone, Mustache, U,
    // class
    EventAggregator
) {

    var AnimationEvents = _.extend({}, EventAggregator.prototype, {

        addExercise: function(exercises) {
            this.trigger("exercise:add", exercises);
        },

        addAnimations: function(animations) {
            this.trigger("exercise:add:animation", animations);
        },

        dragAnimation: function(model, e) {
            this.trigger("exercise:drag:animation", model, e);
        },

        dragAnimationEnd: function(e) {
            this.trigger("exercise:drag:animation:end", e);
        },

        sessionItemDone: function(session, item, value) {
            this.trigger('session:item:done', session, item, value);
        },

        sessionStatsKeypress: function(model, inputName, key, value) {
            this.trigger('session:statsKeypress', model, inputName, key, value);
        },

        saveAndNext: function(exercises, closePanelAfter) {
            this.trigger("exercise:saveAndNext", exercises, closePanelAfter);
        },

        exerciseEditBegin: function(exercise) {
            this.trigger("exercise:editBegin", exercise);
        },

        exerciseEditFinish: function(exercise) {
            this.trigger("exercise:editFinish", exercise);
        },

        historyLoaded: function(history) {
            this.trigger('exercises:historyLoaded', history);
        },

        saveRepsOrLoads: function() {
            this.trigger('exercises:saveRepsOrLoads');
        },

        exerciseRenamed: function(exModel) {
            this.trigger("exercise:renamed", exModel);
        },

        exerciseReverted: function(model) {
            this.trigger('exercise:reverted', model);
        },

        exerciseEdited: function(model) {
            this.trigger("exercise:edited", model);
        },

        refreshPanel: function() {
            this.trigger('refreshPanel');
        }

    });

    return AnimationEvents;

});

